module.exports = __webpack_public_path__ + "static/media/LEFT-DECORATION.7ec0d0fd.svg";